export const OperationCurrency = {
  USD: "USD",
  EUR: "EUR",
  COP: "COP",
  BRL: "BRL",
  MXN: "MXN",
  CLP: "CLP",
  PEN: "PEN",
  PYG: "PYG",
  UYU: "UYU",
  ARS: "ARS",
  HKD: "HKD",
  CNY: "CNY",
  CRC: "CRC",
  GTQ: "GTQ",
  USDT: "USDT",
  USDC: "USDC",
  BINANCE_PAY: "BINANCE_PAY",
} as const;

export type OperationCurrency = (typeof OperationCurrency)[keyof typeof OperationCurrency];

export const PublicAccountPaymentMethod = {
  BANK: "BANK",
  CRYPTO_WALLET: "CRYPTO_WALLET",
} as const;

export type PublicAccountPaymentMethod =
  (typeof PublicAccountPaymentMethod)[keyof typeof PublicAccountPaymentMethod];

export interface PublicAccountUser {
  id: string;
  full_name: string;
  email: string;
}

export interface PublicAccountItem {
  id: string;
  currency: OperationCurrency;
  payment_method: PublicAccountPaymentMethod;
  country_code: string;
  structured_data?: Record<string, unknown> | null;
  internal_alias?: string | null;
  notes?: string | null;
  attachment_urls?: string[] | null;
  qr_image_url?: string | null;
  user_id: string;
  updated_by?: string | null;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  user: PublicAccountUser;
}

export type PublicAccountDetail = PublicAccountItem;

export interface PublicAccountsListResponse {
  data: PublicAccountItem[];
  total: number;
  skip: number;
  limit: number;
  hasMore: boolean;
}

export interface PublicAccountCopyStatsUser {
  id: string;
  email: string;
  full_name: string;
}

export interface PublicAccountCopyStatsByUser {
  user_id: string;
  copy_count: number;
  user: PublicAccountCopyStatsUser;
}

export interface PublicAccountCopyStatsResponse {
  account_id: string;
  total_copies: number;
  last_copied_at: string | null;
  by_user: PublicAccountCopyStatsByUser[];
}
